import api from "../../../../../api";

export const requestGetPartRequestCount = () => api.get("/partrequest/total/count");


export const requestGetAllActiveRequests = (props) => {

    let url = `/partrequest/active/by/user`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestCreateRequest = (props) => api.post('/partrequest', props, { "Content-Type": "multipart/form-data" } );